import React from "react"

export default class Icons extends React.Component {
	render (){
		return (
				<div css={{ transform:'scale(1)',
					         ':hover':{
								transform: 'scale(1.2)',
								transition: 'transform .25s',
								webkitTransition: 'transform .25s'
							  },
							  filter:`drop-shadow(1px  2px 3px rgba(0,0,0,.15))`
						  }}>

				<a href={this.props.href} target="blank">
					
					<img src={this.props.src} 
				     width={this.props.width} 
				     height={this.props.height}
				     alt=""
				     css={{
				     	filter:`drop-shadow(-2px  2px 3px rgba(0,0,0,.2))`
				     }}
				 	/>

				 </a>
			</div>
			)
	}
}

 
